import './BLTNavigationTop.styles.scss'
import {BackButton} from '../../../components/RegularComponents'
import { useDispatch } from 'react-redux'
import {push} from 'connected-react-router'
import { APPLICATION_TYPE_BUSINESS_LICENCE_ADMIN, ROUTE_PATH } from '../../../app/constants'
import { startNSLogout } from '../../../redux/slice/nsLoginSlice'
import { resetQueue } from "../../../redux/slice/bltHomeSlice"

export function BLTNavigationTop(props) { 

    const dispatcher = useDispatch()
    
    return (
        <nav id="navigation" className="ribbon" role="navigation" aria-label="Main Navigation">
            <div className={"container"}>
                <a href="https://novascotia.ca/" hrefLang="en">
                                    <img className="ribbon-img" 
                                        src="https://novascotia.ca/clf/ignition/img/nsvip-en-white-flag.svg" 
                                        alt="Government of Nova Scotia" />
                </a>
                <div className="bltHomeNaviationButtonBar">
                    
                    <div 
                        className="bltHomeNaviationButtonBar-item"
                        onClick={() => {
                            if(props.setPage) {
                                props.setPage(1)
                            }
                            dispatcher(resetQueue())
                            dispatcher(push(ROUTE_PATH.BLT_HOME))
                        }}>
                        <div className="bltHomeNaviationButtonBar-item-icon">
                            <i className="fa fa-lg fa-home"></i>
                        </div>
                        <div className="bltHomeNaviationButtonBar-item-text">
                            Home
                        </div>
                    </div>

                    <div 
                        className="bltHomeNaviationButtonBar-item" 
                        onClick={() => {
                            dispatcher(startNSLogout(APPLICATION_TYPE_BUSINESS_LICENCE_ADMIN))
                        }}>
                        <div className="bltHomeNaviationButtonBar-item-icon">
                            <i className="fa fa-lg fa-user-circle"></i>
                        </div>
                        <div className="bltHomeNaviationButtonBar-item-text">
                            Sign out
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export function BLTScreenNavigation(props) { 
    return (
        <div className="row topMarginNormal">
            <div className="col-3">
                <BackButton 
                    title="Back to previous"
                    onClick={() => {
                        
                        if(props.onWillGoBack) {
                            props.onWillGoBack()
                        }

                        props.history.goBack()
                    }}
                />
            </div>
        </div>
    )
}
